// TODO mixEnd event is firing twice for some reason.

(function () {
    'use strict';

    /**
     * MIXITUP STUFF
     */

    let desktopLayoutThresh = 900;          // desktop (alternate layout) kicks in at 900px
    let mixer = false;
    const filterCats = document.querySelectorAll('.js-filterItem--cat');
    const mixerContainer = document.querySelector('.js-filterItems');
    const classFilterTab = 'postcards__tabs__tab';
    const classFilterTab_active = 'postcards__tabs__tab--active';
    const initialCategory = '.postcardsFilters-all';                            // initial category selected when mixer inited on load
    let mixerActive = false;

    /**
     * Init mixer
     * @param {string} category - needed to select the right class when we recreate the mixer
     */
    function initMixer(category) {
        // if in desktop mode delete any mobile infoboxes first, or else it'll mess it up
        // TODO for some reason the desktop one also disappears

        unsetTriggerSelected(currentPostcard);

        // TODO not sure if this should be here
        if (window.matchMedia(`(min-width: ${desktopLayoutThresh}px)`).matches) {
            const mobileInfoBoxes = mixerContainer.querySelectorAll('.js-postcards-info-dynamic');
            mobileInfoBoxes.forEach(function (elm) {
                elm.remove();
            });
        }

        if (mixerContainer && !mixerActive) {
            mixer = mixitup(mixerContainer, {
                classNames: {
                    block: classFilterTab,
                    elementFilter: ''
                }
            });

            mixerActive = true;

            // set "all" to default so we get the menu highlight.
            mixerContainer.addEventListener('mixEnd', mixEndHandler);
            mixer.filter(category);
        }
    }


    /**
     * Destroy mixer (needs to be destroyed if/when we inject content into the postcards grid)
     */
    function destroyMixer() {
        if (mixer.destroy) {
            // when we destroy the mixer it will remove the active tab class, so we need to grab it first and re-add it afterwards.
            let activeTabIndex = false;
            for (let q = 0; q < filterCats.length; q++) {
                if (filterCats[q].classList.contains(classFilterTab_active)) {
                    activeTabIndex = q;
                    break;
                }
            };
            mixerContainer.removeEventListener('mixEnd', mixEndHandler);
            mixer.destroy();
            mixerActive = false;
            filterCats[activeTabIndex].classList.add(classFilterTab_active);
        }
    }


    /**
     * Mix event handlers
     */
    function mixEndHandler() {
        deleteAllInfo();                                                // they need to be deleted after being mixed out
    }


    /**
     * Bind filterCats events
     */
    function bindFilterCats() {
        filterCats.forEach(function (elm) {
            elm.addEventListener('click', function (e) {
                removeInfo('desktop');                                   // mob gets mixed out by the mixer and then is destroyed via mixEndHandler()
                //allPostcards_handleAccordion_close();
                const filter = e.currentTarget.dataset.filter;

                if (filter) {
                    initMixer(filter);
                }
            });
        });
    }


    /**
     * DETAILS STUFF
     */

    const triggers = document.querySelectorAll('.js-postcardsCardTrigger');                      // clickable postcards
    const destination_desktop = document.querySelector('.js-infoDest_desktop');              // ref to the elm in which desktop info goes
    const classTriggerActive = 'postcards__card--active';                                           // class added to clicked postcard elm
    let currentInfoBoxLayout_mobile = false;                                                 // ref to the current mobile info box layout elm (containing info)
    let currentInfoBox_desktop = false;                                                      // ref to the current desktop info box layout elm (containing info)
    let currentPostcard = false;                                                                     // ref to the postcard elm that has been clicked
    let postcardsOpen = [];                                                                         // array of postcard indexes that are currently open, relative to visible elements (so depends on state of mixer- all, present, past etc)
    const infoAnimClasses_desktop = {
        in: 'postcards__card__info--transIn',
        out: 'postcards__card__info--transOut'
    };

    //const btnCustomPostcard = document.querySelector('.js-btnCustomPostcard');                          // Custom defined button
    const customPostcardInfoDest = document.querySelector('.js-customPostcardInfoDest');          // Custom defined button info


    /**
     * Bind postcard click events
     */
    function bindTriggers() {
        triggers.forEach(function (trigger) {
            trigger.addEventListener('click', function (e) {

                destroyMixer();

                unsetTriggerSelected(currentPostcard);
                setTriggerSelected(e.currentTarget);

                //allPostcards_handleAccordion_close();
                
                //scrollToPos(scrollPos - scrollOffset, scrollTime);

                // Get an array of all triggers
                const arrTriggers = Array.from(triggers);

                // get a list of the ones that don't have display: none (mixitup will apply this depending on filters)
                const arrTriggersVisible = arrTriggers.filter((element) => {
                    const computedStyle = getComputedStyle(element);
                    return computedStyle.display !== 'none';
                });

                // find the index of the one we've clicked
                const clickedIndex = arrTriggersVisible.indexOf(trigger);
                const previousIndex = arrTriggersVisible.indexOf(currentPostcard);

                const previousInfoBoxLayout_mobile = currentInfoBoxLayout_mobile;
                const previousInfoBoxHeight_mobile = previousInfoBoxLayout_mobile ? previousInfoBoxLayout_mobile.querySelector('.postcards__card__info--active').offsetHeight : 0;

                currentPostcard = e.currentTarget;

                // if we're clicking on one which isn't already open (held in postcardsOpen)
                if (postcardsOpen.indexOf(clickedIndex) === -1) {

                    postcardsOpen = [];

                    removeInfo();
                    injectInfo_desktop(currentPostcard);

                    // work out the one to append after and the ones to pull info from
                    let elmToAppendAfter = arrTriggersVisible[clickedIndex];
                    let infoNodes = [];

                    if (clickedIndex % 2 === 0) {                                   // if we've clicked an odd one, get the next one for the position of the info box

                        infoNodes.push(arrTriggersVisible[clickedIndex]);
                        postcardsOpen.push(clickedIndex);

                        if (arrTriggersVisible[clickedIndex + 1]) {
                            elmToAppendAfter = arrTriggersVisible[clickedIndex + 1];
                            infoNodes.push(arrTriggersVisible[clickedIndex + 1]);
                            postcardsOpen.push(clickedIndex + 1);
                        }

                    } else {
                        infoNodes.push(arrTriggersVisible[clickedIndex - 1]);
                        postcardsOpen.push(clickedIndex - 1);
                        infoNodes.push(arrTriggersVisible[clickedIndex]);
                        postcardsOpen.push(clickedIndex);
                    }

                    injectInfo_mobile(infoNodes, elmToAppendAfter);

                    //if (clickedIndex % 2 === 1) {

                    let currentInfoBoxes_mobile = currentInfoBoxLayout_mobile.querySelectorAll('.postcards__card__info');
                    currentInfoBoxes_mobile.forEach(function(currentInfoBox_mobile, index) {
                        if(index === postcardsOpen.indexOf(clickedIndex)) {
                            currentInfoBox_mobile.classList.add('postcards__card__info--active');
                        } else {
                            currentInfoBox_mobile.classList.remove('postcards__card__info--active');
                        }
                    });

                    currentInfoBoxLayout_mobile.style.transform = getTransformForInfo(postcardsOpen.length, postcardsOpen.indexOf(clickedIndex));
                    currentInfoBoxLayout_mobile.firstChild.style.height = getHeightForInfo(currentInfoBoxes_mobile[postcardsOpen.indexOf(clickedIndex)]);
                    currentInfoBoxLayout_mobile.classList.add('postcards__card__info__layout--transition');
                    //}

                    if (window.matchMedia(`(min-width: ${desktopLayoutThresh}px)`).matches) {
                        if (currentPostcard.classList.contains('infoAtTop_desktop')) {
                            let currentInfoBoxBounds_desktop = currentInfoBox_desktop.getBoundingClientRect();
                            let documentScrollTop = document.documentElement.scrollTop;
                            scrollToPos(currentInfoBoxBounds_desktop.top + documentScrollTop - 50, 500, true);
                        }
                    } else { 

                        if (previousInfoBoxLayout_mobile) { // Easy way to check if this is the first info box to be opened.
                            let previousInfoBoxOffset_mobile = (clickedIndex > previousIndex && previousIndex >= 0) ? previousInfoBoxHeight_mobile : 0;
                            let currentPostcardBounds_mobile = currentPostcard.getBoundingClientRect();
                            let documentScrollTop = document.documentElement.scrollTop;
                            scrollToPos(currentPostcardBounds_mobile.top + documentScrollTop - previousInfoBoxOffset_mobile, 250, true);
                        }
                    }

                } else {
                    // for mobile, if necessary we need to do a transform to show the correct data, if there's more than one postcard
                    if (postcardsOpen.length > 1 && currentInfoBoxLayout_mobile) {

                        let currentInfoBoxes_mobile = currentInfoBoxLayout_mobile.querySelectorAll('.postcards__card__info');
                        currentInfoBoxes_mobile.forEach(function(currentInfoBox_mobile, index) {
                            if(index === postcardsOpen.indexOf(clickedIndex)) {
                                currentInfoBox_mobile.classList.add('postcards__card__info--active');
                            } else {
                                currentInfoBox_mobile.classList.remove('postcards__card__info--active');
                            }
                        });
                        
                        currentInfoBoxLayout_mobile.style.transform = getTransformForInfo(postcardsOpen.length, postcardsOpen.indexOf(clickedIndex));
                        currentInfoBoxLayout_mobile.firstChild.style.height = getHeightForInfo(currentInfoBoxes_mobile[postcardsOpen.indexOf(clickedIndex)]);
                        currentInfoBoxLayout_mobile.classList.add('postcards__card__info__layout--transition');
                    }
                    removeInfo('desktop');
                    injectInfo_desktop(currentPostcard);

                    if (window.matchMedia(`(min-width: ${desktopLayoutThresh}px)`).matches) {
                        if (currentPostcard.classList.contains('infoAtTop_desktop')) {
                            let currentInfoBoxBounds_desktop = currentInfoBox_desktop.getBoundingClientRect();
                            let documentScrollTop = document.documentElement.scrollTop;
                            scrollToPos(currentInfoBoxBounds_desktop.top + documentScrollTop - 50, 500, true);
                        }
                    } else {
                        let currentPostcardBounds_mobile = currentPostcard.getBoundingClientRect();
                        let documentScrollTop = document.documentElement.scrollTop;
                        scrollToPos(currentPostcardBounds_mobile.top + documentScrollTop, 250, true);
                    }
                }
            });
        });
    }


    /**
     * Bind resize event
     */
    function bindResize() {
        window.addEventListener('resize', function () {
            if (window.matchMedia(`(min-width: ${desktopLayoutThresh}px)`).matches) {
                if (currentInfoBox_desktop && currentPostcard) {
                    if(!currentPostcard.classList.contains('infoAtTop_desktop')) {
                        currentInfoBox_desktop.style.top = `${currentPostcard.offsetTop}px`;
                    }
                    destination_desktop.style.height = (currentPostcard.offsetTop + currentInfoBox_desktop.offsetHeight) + 'px';
                }
            }
            recalculateHeight_mobile();
        });
    }


    /**
     * Remove all info clones (mob and desktop)
     */
    function deleteAllInfo(mode = false) {
        let postcardsInfos;
        if (!mode) {                                                            // if mode is false, remove all regardless of mob or desk
            postcardsOpen = [];
            postcardsInfos = document.querySelectorAll('.js-postcards-info-dynamic');
        } else if (mode === 'desktop') {
            postcardsInfos = document.querySelectorAll('.js-infoDest_desktop .js-postcards-info-dynamic');
        }

        postcardsInfos.forEach(function (elm) {
            elm.remove();
        });
    }


    /**
     * Get a postcard's data from its clicked element
     * @param {Node} postcardElm - postcard DOM node that has been clicked
     * @returns {Object} - object consisting of data from that node's data attributes
     */
    function getPostcardInfo(postcardElm) {
        if (!postcardElm instanceof Node) {
            return false;
        }

        let postcardInfo = {};

        postcardInfo = postcardElm.querySelector('.postcards__card__info');

        return postcardInfo;
    }


    /**
     * Inject info into desktop pane
     * @param {Node} currentPostcard
     */
    function injectInfo_desktop(currentPostcard) {

        let postcardInfo = getPostcardInfo(currentPostcard).cloneNode(true);

        postcardInfo.classList.remove('hidden');
        postcardInfo.classList.add('js-postcards-info-dynamic');
        if(!currentPostcard.classList.contains('infoAtTop_desktop')) {
            postcardInfo.style.top = `${currentPostcard.offsetTop}px`;
        }
        postcardInfo.classList.add(infoAnimClasses_desktop.in);

        postcardInfo.addEventListener('animationend', function (e) {
            e.currentTarget.classList.remove(infoAnimClasses_desktop.in);
        }, { once: true });

        currentInfoBox_desktop = postcardInfo;

        destination_desktop.appendChild(postcardInfo);
        destination_desktop.style.height = (currentPostcard.offsetTop + postcardInfo.offsetHeight) + 'px';
    }


    /**
     * Add the infobox at the right places for mobile and desktop
     * @param {Array} nodes - nodes from which info will be pulled
     * @param {Node} elmInsertAfter - where to insert the infobox
     * @param {Node} currentPostcard - the particular trigger node clicked
     */
    function injectInfo_mobile(nodes, elmInsertAfter) {
        // first we need to create a div that will take the height. It starts at 0
        const heightElm = document.createElement('div');
        heightElm.classList.add('postcards__card__info__heightener');

        // then we need to create a div for the width
        const widthElm = document.createElement('div');
        const containerWidth = (nodes.length * 100) + '%';
        widthElm.style.width = containerWidth;
        widthElm.classList.add('postcards__card__info__layout');

        // then we need to assemble the postcard nodes and add them to the height elm
        nodes.forEach(function (node) {
            let postcardInfo = getPostcardInfo(node).cloneNode(true);
            postcardInfo.classList.remove('hidden');
            heightElm.appendChild(postcardInfo);
        });

        // then we need to inject the height elm plus contents into the width elm
        widthElm.appendChild(heightElm);

        // then we need to inject the width elm into another div due to postcards section using display: flex
        const parentElm = document.createElement('div');
        parentElm.classList.add('js-postcards-info-dynamic', 'hideAboveTabletBigger', 'mix', 'overflowHidden');
        parentElm.appendChild(widthElm);
        elmInsertAfter.insertAdjacentElement('afterend', parentElm);

        // then we need to get the height of the first contents
        //var heightElmHeight = heightElm.firstChild.clientHeight;

        // then need to assign current info box mobile
        currentInfoBoxLayout_mobile = widthElm;

        // set the height elm to height 0
        heightElm.style.height = '0px';

        // needs to be in a setTimeout or the transition won't work!
        //setTimeout(function () {
            //heightElm.style.height = heightElmHeight + 'px';
        //}, 16);
    }


    /**
     * Remove postcardInfo elements, set related events if applicable
     * @param {boolean|string} mode - 'desktop', 'mobile' or false to remove both
     */
    function removeInfo(mode = false) {
        if (mode !== 'mobile') {
            if (currentInfoBox_desktop) {
                if (window.matchMedia(`(min-width: ${desktopLayoutThresh}px)`).matches) {
                    currentInfoBox_desktop.classList.add(infoAnimClasses_desktop.out);
                    currentInfoBox_desktop.addEventListener('animationend', function (e) {
                        e.currentTarget.remove();
                    }, { once: true });
                } else {
                    currentInfoBox_desktop.remove();
                    currentInfoBox_desktop = false;
                }
            }
        }

        if (mode !== 'desktop') {
            if (currentInfoBoxLayout_mobile) {
                if (window.matchMedia(`(max-width: ${desktopLayoutThresh}px)`).matches) {
                    currentInfoBoxLayout_mobile.firstElementChild.style.height = `0px`;
                    currentInfoBoxLayout_mobile.firstElementChild.addEventListener('transitionend', function (e) {
                        e.currentTarget.parentNode.parentNode.remove();
                    }, { once: true });
                } else {
                    if (currentInfoBoxLayout_mobile) {
                        currentInfoBoxLayout_mobile.parentNode.remove();
                        currentInfoBoxLayout_mobile = false;
                    }
                }
            }
        }
    }


    /**
     * Recalculate the height of a infobox on mobile, used for resize
     */
    function recalculateHeight_mobile() {
        if (!currentInfoBoxLayout_mobile) return;

        let currentInfoBox_mobile = currentInfoBoxLayout_mobile.querySelector('.postcards__card__info--active');
        if(!currentInfoBox_mobile) return;

        const heightDiv = currentInfoBoxLayout_mobile.firstElementChild;
        const newHeight = currentInfoBox_mobile.offsetHeight;
        heightDiv.style.height = `${newHeight}px`;
    }


    /**
     * For the mobile info box layout, check whether it needs to be transformed (eg if two companies are present the info will be within a box of 200% width, so we'll need to transform it to show the postcard)
     * @param {number} postcardsOpenLength - length of postcardsOpen array
     * @param {*} postcardsOpenIndex - index of clicked postcard within array
     * @returns
     */
    function getTransformForInfo(postcardsOpenLength, postcardsOpenIndex) {
        let chunks = 100 / postcardsOpenLength;
        let transformVal = (chunks * postcardsOpenIndex) * -1;
        let transform = `translateX(${transformVal}%)`;
        return transform;
    }

    /**
     * For the mobile info box layout, check whether it needs to be resized in height (eg if two companies are present, we'll need to resize depending on the height of the info for the current company)
     * @returns
     */
    function getHeightForInfo(currentInfoBox_mobile) {
        let postcardsOpenInfoHeight = currentInfoBox_mobile.offsetHeight;
        return postcardsOpenInfoHeight + 'px';
    }

    /**
     * Add selected class to trigger
     * @param {Node} trigger
     */
    function setTriggerSelected(trigger) {
        if (trigger.classList) {
            trigger.classList.add(classTriggerActive);
        }
    }


    /**
     * Remove selected class from trigger
     * @param {Node} trigger
     */
    function unsetTriggerSelected(trigger) {
        if (trigger.classList) {
            trigger.classList.remove(classTriggerActive);
        }
    }


    /**
     * Unsets all triggers from being selected
     */
    function unsetAllTriggersSelected() {
        triggers.forEach(function (elm) {
            elm.classList.remove(classTriggerActive);
        });
    }


/*
    function bindClick_btnCustomPostcard() {
        if (btnCustomPostcard) {
            btnCustomPostcard.addEventListener('click', function () {
                allPostcards_handleAccordion(customPostcardInfoDest);
                unsetAllTriggersSelected();
                removeInfo(false);
                postcardsOpen = [];
            });
        }
    }
*/

    /**
     * Handle All Companies list opening and closing
     * TODO would be nice to integrate this into the code used for Team accordions but I've not done it as I need the button and target to work via IDs whereas the Team ones work via the target is nested within the trigger.
     */
    /*
    function allPostcards_handleAccordion(customPostcardInfoDest) {
        
        // get the inner div that will have a height
        const customPostcardInfoDest_heightDiv = customPostcardInfoDest.querySelector('.js-customPostcardInfoDest-height');

        // get the height of the inner div
        let customPostcardInfoDest_heightDiv_height = customPostcardInfoDest_heightDiv ? customPostcardInfoDest_heightDiv.clientHeight : false;

        // get the height of the container (starts at 0px)
        var customPostcardInfoDest_cont_height = parseInt(customPostcardInfoDest.style.height);

        if (customPostcardInfoDest_heightDiv_height !== false) {
            if (customPostcardInfoDest_cont_height === 0) {
                allPostcards_handleAccordion_open(customPostcardInfoDest_heightDiv_height);
            } else {
                allPostcards_handleAccordion_close();
            }
        }
    }
*/

    /**
     * Open accordion
     * @param {number} customPostcardInfoDest_heightDiv_height
     */
    /*
    function allPostcards_handleAccordion_open(customPostcardInfoDest_heightDiv_height) {
        if(!customPostcardInfoDest) return;

        customPostcardInfoDest.style.height = `${customPostcardInfoDest_heightDiv_height}px`;
        customPostcardInfoDest.style.opacity = '1';
        customPostcardInfoDest.style.pointerEvents = 'all';
        window.addEventListener('resize', allPostcards_handleResize);

        const scrollOffset = window.matchMedia(`(min-width: ${desktopLayoutThresh}px)`).matches ? 200 : 200;
        const scrollTime = window.matchMedia(`(min-width: ${desktopLayoutThresh}px)`).matches ? 1500 : 500;
        let scrollPos = customPostcardInfoDest.parentNode.offsetTop

        // if we're on mobile we need to get the height of any open postcard to offset against the scroll.
        if (currentInfoBoxLayout_mobile && window.matchMedia(`(max-width: ${desktopLayoutThresh - 1}px)`).matches) {
            scrollPos -= currentInfoBoxLayout_mobile.clientHeight - 2;   // the -2 is a sweetener as for some reason it's off by 2px otherwise. Perhaps due to the transition or something but no time to debug it now.
        }

        scrollToPos(scrollPos - scrollOffset, scrollTime);
    }
*/

    /**
     * Close accordion
     */
    /*
    function allPostcards_handleAccordion_close() {
        if(!customPostcardInfoDest) return;

        customPostcardInfoDest.style.height = '0px';
        customPostcardInfoDest.style.opacity = '0';
        customPostcardInfoDest.style.pointerEvents = 'none';
        window.removeEventListener('resize', allPostcards_handleResize);
    }
*/

    /**
     * Accordion window resize event
     */
    /*
    function allPostcards_handleResize() {
        customPostcardInfoDest.style.height = `${customPostcardInfoDest.querySelector('.js-customPostcardInfoDest-height').clientHeight}px`;
    }
        */


    /**
     * Let's GOOOOOOOOOOOOO
     */
    if (triggers.length > 0 && destination_desktop) {
        bindFilterCats();
        initMixer(initialCategory);
        bindTriggers();
        //bindClick_btnCustomPostcard();
        bindResize();

        // open the first one
        document.addEventListener('DOMContentLoaded', function(event) {
            triggers[0].click();
        });
        
    }
})();